export default __webpack_public_path__ + "static/media/personal_portfolio-02.911010c0.png";